export class MapWarehouseAreasCommand {
    requestId: number;
    senderWarehouseAreaPartnerCode: string;
    senderWarehouseAddress: string;
    senderBankBranchName: string;
    recipientWarehouseAreaPartnerCode: string;
    recipientWarehouseAddress: string;
    recipientBankBranchName: string;
}